<tabs-inner-wrap>
  <ng-container *ngIf="!isLoading; else loadingTemplate">
    <details-section
      title="Testers"
      [showDetails]="false"
      [description]="readOnly === false ? description : ''"
    >
      <div class="container">
        <div *ngIf="readOnly === false" class="testing-content">
          <div style="max-width: 800px">
            <qai-multiselect
              #multiselect
              [options]="searchOptions"
              [placeholder]="'Search users'"
              [placement]="'below-start'"
              [offset]="4"
              [startIcon]="'search'"
              (valueChange)="searchValueChange($event)"
              (selectionChange)="searchSelectionChange($event)"
              [value]="defaultSelection"
              [clearButton]="clearOption"
              [selectionDisplayMode]="'single-row-truncated'"
              [visibleOptionsSelectionMode]="visibleOptionsSelectionMode"
              [persistSearch]="true"
            ></qai-multiselect>
          </div>

          <div class="sendAssignments">
            <button
              qai-button
              [shape]="'normal'"
              [kind]="'tertiary'"
              [size]="'medium'"
              [disabled]="readOnly || testersList.length === 0 || networkRequestInProgress || !readyForPublish"
              (click)="handleSendAssignmentClick($event)"
            >
              Send test assignments
            </button>
          </div>
        </div>

        <div class="table-wrapper">
          <qai-table
            [headers]="headers"
            [data]="tableData"
            [striped]="false"
            (rowAction)="onTableRowAction($event)"
            [initialSortColumn]="initialSortColumn"
            [initialSortDirection]="initialSortDirection"
          ></qai-table>
        </div>
      </div>
    </details-section>
  </ng-container>

  <ng-template #loadingTemplate>
    <div class="loading-container">
      <qai-loading [size]="'medium'"></qai-loading>
    </div>
  </ng-template>
</tabs-inner-wrap>
